import { campaignsSettingsStore } from '@client/stores/page-settings';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

export const saveCampaign = {
  element: 'div.flex-align--center.row > div.col-4.col-sm-6.col-md-6.text-right > button.btn.btn-primary',
  popover: {
    title: 'Saving Your Changes',
    description:
      "When you're done editing, click <strong>&quot;Update&quot;</strong> in the top-right corner to save your changes.",
    onNextClick: () => {
      const closeBtn = document.querySelector(
        '#campaign-editor > div.page-header > div > div.flex-align--center.row > div.col-4.col-sm-6.col-md-6.text-right > button.hide--mobile.me-2.btn.btn-secondary'
      );

      campaignsSettingsStore.subscribe((campaigns) => {
        campaigns.tours.editHasToured = true;
      })();

      if (closeBtn) {
        closeBtn.click();

        GLOBAL_DRIVER_OBJECT.destroy();
      }
    }
  }
};
